import React, { ElementType } from 'react';
import { Link } from 'react-router-dom';
import { Shelf } from '@src/remotes/Shelf';
import { useBookmarkActions } from '@src/hooks';
import { useMemberExperienceAuth } from '@guildeducationinc/auth-frontend-tools';
import { RecommendationCategory } from '@src/graphqlTypes/catalogServiceTypes';
import { getUserValuesForPath } from '@src/constants/getUserValuesForPath';
import { useBookmarks } from '../Providers/BookmarksProvider';
import styles from './PersonalizedShelf.module.scss';

export const PersonalizedShelf: React.FC = () => {
	const { bookmarks } = useBookmarks();
	const { updateBookmark } = useBookmarkActions();
	const { getAccessToken, getIdToken, userFromIdToken: user } = useMemberExperienceAuth();
	const authUser = getUserValuesForPath(user);

	return (
		<>
			<div className={styles.personalizedShelf}>
				<Shelf
					LinkComponent={Link as unknown as ElementType}
					bookmarks={bookmarks}
					getAccessToken={getAccessToken}
					getIdToken={getIdToken}
					product='catalog'
					recommendationCategory={RecommendationCategory.PERSONALIZED}
					shelfType='personalized_shelf'
					subhead='Check out some programs we think you might like.'
					updateBookmark={updateBookmark}
					user={authUser}
				/>
			</div>
		</>
	);
};
